module.exports = __webpack_public_path__ + "img/sld_mfm_inv_13_t1_b1_dark.26e172ca.svg";